import * as Sentry from "@sentry/vue";

class APIError extends Error {
  constructor(message, axiosError) {
    super(message);
    Object.assign(this, axiosError);
    this.message = message;
    this.name = "APIError";
  }
}

class SentryPlugin {
  constructor() {
    this.dsn = process.env.VUE_APP_SENTRY_DSN || null;
    this.environment = process.env.NODE_ENV || "development"; // "production" ou "development"
  }

  install(Vue) {
    if (!this.dsn) {
      console.warn("Sentry DSN is not configured. Sentry will not be initialized.");
      return;
    }

    Sentry.init({
      Vue,
      dsn: this.dsn,
      sendDefaultPii: true,
      environment: this.environment
    });

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const currentAccount = user.account;

      Sentry.setTag("account_id", currentAccount.id);
      Sentry.setTag("account_name", currentAccount.name);

      Sentry.setUser({
        id: user.id,
        email: user.email,
      });

    } catch (error) {
      console.error('Tenant não selecionado')
    }
  }

  sendAxiosError(error) {
    let path = null;
    const method = error.config?.method?.toUpperCase() || "UNKNOWN";
    const status = error.response?.status || "NO_RESPONSE";

    try {
      const url = error.request?.responseURL || error.config?.url || null;
      path = url ? new URL(url, window.location.origin).pathname : null;
    } catch (e) {
      path = error.config?.url || null;
    }

    if (status >= 400 && status <= 500 && status !== 404) {
      Sentry.withScope((scope) => {
        scope.setFingerprint(['axios', path]);
        scope.setTransactionName(`Axios ${method} ${path}`);
        scope.setTag('http_status', status);
        scope.setTag('http_method', method);
        Sentry.captureException(new APIError(`API endpoint ${status} error ${path}`, error), {
          extra: {
            data: error.response?.data,
            status,
            method,
            path,
          },
        });

      });
    }
  }
}
export default new SentryPlugin();
